<template>
  <div id="create-point">
    <div class="container mb-4">
      <form @submit.prevent>
        <button @click="closeCreatePoint()" class="btn btn-outline-primary btn-sm mb-2"><i class="fal fa-arrow-left"></i> Back to Exploration</button>
        <!-- TITLE -->
        <div class="form-group">
          <label>Point Title</label>
          <input required v-model="point.title" class="form-control" />
        </div><!-- /.form-group -->
        <!-- EMBED CODE -->
        <div class="form-group">
          <label>Embed Code</label>
          <textarea v-model="point.embedCode" class="form-control" />
        </div><!-- /.form-group -->
        <!-- ADDRESS AND COORDINATES -->
        <div class="form-group">
          <label>Location</label>
          <vue-google-autocomplete
            ref="address"
            id="autoAddress"
            classname="form-control"
            placeholder="Search for an address to add pin to map!"
            v-on:placechanged="getAddressData"
          ></vue-google-autocomplete><br>
          <div id="map" style="background-color:black;width:100%;height:300px;"></div>
        </div><!-- /.form-group -->
        <!-- IMAGES INPUT -->
        <div class="form-group">
          <label>Images</label>
          <MediaInput v-on:mediaDelivery="mediaDelivery($event)" v-on:processingMedia="processingMedia($event)" :mediaObject="point.images"></MediaInput>
        </div><!-- /.form-group -->
        <!-- PRIVATE MODE CHECKBOX -->
        <div class="form-group form-check">
          <input v-model="point.private" type="checkbox" class="form-check-input" id="privatePointCheck">
          <label class="form-check-label" for="privatePointCheck">Private Point (Only visible when logged in)</label>
        </div>
        <!-- SUBMIT BUTTON -->
        <button v-if="processingMedias == false" @click="savePoint()" class="btn btn-outline-success">Save</button>
        <button v-if="processingMedias == true" class="btn btn-warning">Processing...</button>
        <button @click="closeCreatePoint()" class="btn btn-outline-warning">Cancel</button>
      </form>
    </div><!-- /.container mt-4 -->
  </div>
</template>

<script>
  const fb = require('../firebaseConfig.js')
  import VueGoogleAutocomplete from 'vue-google-autocomplete'
  import MediaInput from './MediaInput.vue'

  export default {
    props: ['exploration', 'index'],
    data() {
      return {
        point: {
          title: '',
          embedCode: '',
          address: {
            street_number: '',
            route: '',
            locality: '',
            administrative_area_level_1: '',
            administrative_area_level_2: '',
            postal_code: ''
          },
          images: [],
          coordinates: {
            latitude: '',
            longitude: ''
          },
          private: false,
          nearby: false
        },
        editMode: false,
        processingMedias: false
      }
    },
    components: { VueGoogleAutocomplete, MediaInput },
    created() {
      if (this.index != null) {
        this.point = this.exploration.points[this.index]
        this.editMode = true
      } else {
        this.editMode = false
      }
      this.initMap()
    },
    methods: {
      slugify(text) {
        text = text.toString().toLowerCase().trim();

        const sets = [
          {to: 'a', from: '[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶ]'},
          {to: 'c', from: '[ÇĆĈČ]'},
          {to: 'd', from: '[ÐĎĐÞ]'},
          {to: 'e', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]'},
          {to: 'g', from: '[ĜĞĢǴ]'},
          {to: 'h', from: '[ĤḦ]'},
          {to: 'i', from: '[ÌÍÎÏĨĪĮİỈỊ]'},
          {to: 'j', from: '[Ĵ]'},
          {to: 'ij', from: '[Ĳ]'},
          {to: 'k', from: '[Ķ]'},
          {to: 'l', from: '[ĹĻĽŁ]'},
          {to: 'm', from: '[Ḿ]'},
          {to: 'n', from: '[ÑŃŅŇ]'},
          {to: 'o', from: '[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]'},
          {to: 'oe', from: '[Œ]'},
          {to: 'p', from: '[ṕ]'},
          {to: 'r', from: '[ŔŖŘ]'},
          {to: 's', from: '[ßŚŜŞŠ]'},
          {to: 't', from: '[ŢŤ]'},
          {to: 'u', from: '[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]'},
          {to: 'w', from: '[ẂŴẀẄ]'},
          {to: 'x', from: '[ẍ]'},
          {to: 'y', from: '[ÝŶŸỲỴỶỸ]'},
          {to: 'z', from: '[ŹŻŽ]'},
          {to: '-', from: '[·/_,:;\']'}
        ];

        sets.forEach(set => {
          text = text.replace(new RegExp(set.from,'gi'), set.to)
        });

        return text.toString().toLowerCase()
          .replace(/\s+/g, '-')           // Replace spaces with -
          .replace(/&/g, '-and-')         // Replace & with 'and'
          .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
          .replace(/\--+/g, '-')         // Replace multiple - with single -
          .replace(/^-+/, '')             // Trim - from start of text
          .replace(/-+$/, '');             // Trim - from end of text
      },
      processingMedia(e) {
        this.processingMedias = e
      },
      mediaDelivery(mediaPayload) {
        this.point.images = mediaPayload
      },
      initMap() {
        if (this.editMode == true) {
          let self = this
          if (this.point.coordinates.latitude) {
            // IF THERE ARE COORDINATES
            setTimeout(function () {
              let map = new google.maps.Map(document.getElementById('map'), {
                center: {lat: self.point.coordinates.latitude, lng: self.point.coordinates.longitude},
                zoom: 12
              })
              let marker = new google.maps.Marker({
                map: map,
                draggable: true,
                position: map.center
              })
              google.maps.event.addListener(marker, 'dragend', function(marker){
                let lat = marker.latLng.lat();
                let lng = marker.latLng.lng();
                self.point.coordinates.latitude = lat
                self.point.coordinates.longitude = lng
              })
            }, 10)
          } else {
            // IF NO COORDINATES, SET TO 0,0
            setTimeout(function () {
              let map = new google.maps.Map(document.getElementById('map'), {
                center: {lat: 0, lng: 0},
                zoom: 2
              })
              let marker = new google.maps.Marker({
                map: map,
                draggable: true,
                position: map.center
              })
              google.maps.event.addListener(marker, 'dragend', function(marker){
                let lat = marker.latLng.lat();
                let lng = marker.latLng.lng();
                self.point.coordinates.latitude = lat
                self.point.coordinates.longitude = lng
              })
            }, 10)
          }
        } else {
          // IF NOT IN EDIT MODE
          setTimeout(function () {
            new google.maps.Map(document.getElementById('map'), {
              center: {lat: 0,lng: 0},
              zoom: 2
            });
          }, 10)
        }
      },
      getAddressData(addressData, placeResultData, id) {
        this.point.address = {
          street_number: addressData.street_number || '',
          route: addressData.route || '',
          locality: addressData.locality || '',
          administrative_area_level_1: addressData.administrative_area_level_1 || '',
          administrative_area_level_2: addressData.administrative_area_level_2 || '',
          postal_code: addressData.postal_code || ''
        }
        let center = {lat: addressData.latitude, lng: addressData.longitude}
        this.point.coordinates.latitude = addressData.latitude
        this.point.coordinates.longitude = addressData.longitude
        let map = new google.maps.Map(document.getElementById('map'), {});
        map.setCenter(center);
        map.setZoom(12);
        let marker = new google.maps.Marker({
          map: map,
          draggable: true,
          position: center
        })
        let self = this
        google.maps.event.addListener(marker, 'dragend', function(marker){
          let lat = marker.latLng.lat();
          let lng = marker.latLng.lng();
          self.point.coordinates.latitude = lat
          self.point.coordinates.longitude = lng
        })
      },
      savePoint() {
        // Slugify the title and add it to the object
        this.point.slug = this.slugify(this.point.title)
        if (this.editMode == false) {
          this.exploration.points.unshift(this.point)
          fb.explorationsCollection.doc(this.exploration.id).update({
            points: this.exploration.points
          }).then(ref => {
            this.$emit('closeCreatePoint')
          })
        }
        if (this.editMode == true) {
          this.exploration.points[this.index] = this.point
          fb.explorationsCollection.doc(this.exploration.id).update({
            points: this.exploration.points
          }).then(ref => {
            this.$emit('closeCreatePoint')
          })
        }
      },
      closeCreatePoint() {
        this.$emit('closeCreatePoint')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CreatePoint.vue